<template>
  <div class="chose-shipping-options">
    <div class="field field--shipping-method">
      <div class="title is-4 has-text-grey">
        {{ $t("orderDetails.labels.shippingMethod") }}
      </div>
      <div class="control" :class="{ 'is-disabled': !isEditable }">
        <label
          class="radio my-3"
          v-for="option in shippingMethods"
          :key="`shipping-method-option__${option._id}`"
        >
          <input
            type="radio"
            :id="option._id"
            :value="option.shippingMethodId"
            :disabled="!isEditable"
            name="shipping-method"
            v-model="shippingMethod"
            :is-default="true"
          />
          <div class="shipping-method__info">
            <div class="shipping-method__label">
              {{ option.shippingMethod }} -
              <strong class="has-text-primary-dark">
                <template
                  v-if="
                    option.shippingMethod === 'Standard-Versand' &&
                      positionPrice.netPrice > 221.072644
                  "
                >
                  {{ $t("discount.free") }}
                </template>
                <template v-else>
                  {{ option.pricing.netPrice | currency }}
                </template>
              </strong>
            </div>
            <div class="shipping-method__time">
              {{ $t("orderDetails.labels.productionTime") }}
              <strong>
              {{ $tc("orderDetails.businessDays", productionTimeDays) }}
              </strong>
            </div>
            <div class="shipping-method__time">
              + {{ $t("orderDetails.labels.deliveryTime") }}
              <strong>
                {{ $tc("orderDetails.regularDays", option.shippingTimeDays) }}
              </strong>
            </div>
          </div>
        </label>
      </div>
    </div>
    <template v-if="isEditable">
      <div class="title is-4 has-text-grey mt-6">
        {{ $t("orderDetails.labels.deliveryAndProductionTime") }}
      </div>
      <div class="subtitle is-5">
        <strong class="has-text-dark">{{
          $tc(
            "orderDetails.businessDays",
            productionTimeDays + chosenShippingMethod.shippingTimeDays
          )
        }}</strong>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { calculateTaxes } from "../../../utilities/tax-calculations";

export default {
  name: "ChooseShippingOption",
  data() {
    return {
      shippingMethod: null,
    };
  },
  props: {
    isEditable: {
      required: false,
      default: true,
    },
  },
  methods: {
    getMaagtechnicProductionTime() {
      const estimatedProductionTimesByWeekday = {
          0: 9, // Sunday
          1: 8, // Monday
          2: 7, //...
          3: 6,
          4: 5,
          5: 4,
          6: 9, //Saturday
      };

      return estimatedProductionTimesByWeekday[new Date().getDay()];
    },
  },
  computed: {
    ...mapGetters([
      "allCartItems",
      "paymentDetails",
      "taxRate",
      "isBusinessCustomer",
      "shippingCountryById",
      "orderTrackingInfo",
      "discountApplied",
      "discount",
      "positionPrice",
      "cumulatedProductionTime"
    ]),
    shippingMethods() {
      return this.$store.getters
        .shippingCountryById(this.paymentDetails.shippingAddress.countryId)
        .shippingMethods.map((shippingMethod) => {
          let price = shippingMethod.priceCents;
          if (
            shippingMethod.shippingMethod === "Standard-Versand" &&
            (this.positionPrice.netPrice > 221.072644 ||
              (this.discountApplied && this.discount.rules.freeShipping))
          ) {
            price = 0;
          }
          return {
            ...shippingMethod,
            pricing: calculateTaxes(price, this.taxRate),
          };
        });
    },
    chosenShippingMethod() {
      let shippingMethod;
      if (
        this.orderTrackingInfo.shippingMethod &&
        this.orderTrackingInfo.shippingCosts
      ) {
        shippingMethod = {
          ...this.orderTrackingInfo.shippingMethod,
          pricing: this.orderTrackingInfo.shippingCosts,
          priceCents:
            this.orderTrackingInfo.shippingCosts.calculatedTaxes.price * 100,
        };
      } else {
        shippingMethod = this.$store.getters
          .shippingCountryById(this.paymentDetails.shippingAddress.countryId)
          .shippingMethods.find(
            (method) =>
              method.shippingMethodId === this.paymentDetails.shippingMethodId
          );
      }
      let price =
        this.positionPrice.netPrice > 221.072644 ||
        (this.discountApplied && this.discount.rules.freeShipping)
          ? 0
          : shippingMethod.priceCents;
      return {
        ...shippingMethod,
        pricing: calculateTaxes(price, this.taxRate),
      };
    },
    productionTimeDays() {
      let date = new Date(Date.now());
      let day = date.getDay();
      switch (day) {
        case 0:
          return 9;
        case 1:
          return 8;
        case 2:
          return 7;
        case 3:
          return 6;
        case 4:
          return 5;
        case 5:
          return 4;
        case 6:
          return 9;
      }
    },
  },
  watch: {
    shippingMethod(value) {
      this.$store.dispatch("updatePaymentDetails", {
        paymentDetails: { ...this.paymentDetails, shippingMethodId: value },
      });
    },
  },
  async created() {
    await this.$store.dispatch("fetchShippingCountries");

    this.shippingMethod = this.shippingMethods[0].shippingMethodId;
    if (this.orderTrackingInfo.shippingMethod) {
      this.shippingMethod = this.orderTrackingInfo.shippingMethod.id;
    }
  },
};
</script>
<style lang="scss">
.chose-shipping-options {
  .control.is-disabled {
    opacity: 0.5;
  }
}
</style>
